import React, { useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import html2pdf from "html2pdf.js";
import CrystalReport from "./CrystalReport";

const ViewAllotement = () => {
  const props = useLocation()?.state?.data || [];
  const reportRef = useRef();
  const [base64Image, setBase64Image] = useState("");

  const logoUrl =
    "https://upload.wikimedia.org/wikipedia/commons/thumb/a/a9/Jharkhand_Rajakiya_Chihna.svg/300px-Jharkhand_Rajakiya_Chihna.svg.png";

  useEffect(() => {
    convertToBase64(logoUrl);
  }, []);

  const convertToBase64 = (url) => {
    fetch(url)
      .then((response) => response.blob())
      .then((blob) => {
        const reader = new FileReader();
        reader.onloadend = () => setBase64Image(reader.result);
        reader.readAsDataURL(blob);
      })
      .catch((error) => console.error("Error converting image:", error));
  };

  const handleDownload = () => {
    const element = reportRef.current;
    if (!element) return;

    html2pdf()
      .set({
        margin: 4,
        filename: "Deputy-Allotement-Report.pdf",
        image: { type: "jpeg", quality: 0.98 },
    html2canvas: {
  scale: 3,     // increased from 2 to 3
  useCORS: true
}
,
        jsPDF: { unit: "mm", format: "a4", orientation: "portrait" },
        pagebreak: { mode: ["css", "legacy"], before: "#pagebreak" },
      })
      .from(element)
      .save();
  };

  return (
    <div className="p-8 bg-white text-black mt-4 mx-auto border border-gray-300 shadow-md rounded-md relative max-w-full">
      {/* Header */}
      <div className="flex items-center justify-between mb-6">
        <h1 className="text-xl font-bold border-b-2 border-green-500 pb-1">
          Event: {props[0]?.EventName || "N/A"}, Pakur
        </h1>
        <button
          onClick={handleDownload}
          className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700 text-sm shadow hover:shadow-lg"
        >
          Download
        </button>
      </div>

      {/* Table */}
      <div className="overflow-x-auto">
        <table className="w-full border border-gray-400 text-sm">
          <thead className="bg-gray-100 text-gray-700">
            <tr>
              <th className="border p-2">S.No.</th>
              <th className="border p-2">Deputy Code</th>
              <th className="border p-2">Allotted Deputy Name</th>
              <th className="border p-2">Designation</th>
              <th className="border p-2">Area Name</th>
              <th className="border p-2">Date</th>
              <th className="border p-2">Time</th>
            </tr>
          </thead>
          <tbody>
            {props.map((item, index) => (
              <tr key={item.DutyAllotementCode + index} className="odd:bg-white even:bg-gray-50 text-center">
                <td className="border p-2">{index + 1}</td>
                <td className="border p-2">{item.StaffCode}</td>
                <td className="border p-2">{item.FullName}</td>
                <td className="border p-2">{item.Designation}</td>
                <td className="border p-2 text-left">{item.AreaName}</td>
                <td className="border p-2">
                  {new Date(item.EventStartDate).toISOString().split("T")[0]} to{" "}
                  {new Date(item.EventEndDate).toISOString().split("T")[0]}
                </td>
                <td className="border p-2">
                  {item.StartTime ? (
                    <>
                      {formatTime(item.StartTime)} to {formatTime(item.EndTime)}
                    </>
                  ) : (
                    <>
                      {formatTimeFromDate(item.EventStartDate)} to {formatTimeFromDate(item.EventEndDate)}
                    </>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Hidden Report for PDF */}
      <div className="hidden">
        <CrystalReport ref={reportRef} props={props} />
      </div>
    </div>
  );
};

// Helpers
const formatTime = (timeStr) => {
  return new Date(`1970-01-01T${timeStr}`).toLocaleTimeString([], {
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
  });
};

const formatTimeFromDate = (dateStr) => {
  return new Date(dateStr).toLocaleTimeString([], {
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
  });
};

export default ViewAllotement;
